import React, {FC} from 'react';
import {Container, Grid, Paper} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';


import BottlesIcon from '../../assets/foodAndRestaurant.svg';
import FacebookIcon from '../../assets/facebook.svg';
import InstagramIcon from '../../assets/instagram.svg';
import Cups from '../../assets/cups.png';
import Barrils from '../../assets/barrils.png';
import infoContainerStyles from '../../styles/Home/InfoContainer';

const InfoContainer: FC = () => {
    const classes = infoContainerStyles();
    return(
        <Box mt={10} mb={10}>
            <Container>
                <Grid container spacing={2} justify='center'>
                    <Grid item sm={12} md={6} className={classes.gridMaxWidth}>
                        <Paper className={classes.control}>
                            <p>Visita nuestra tienda</p>
                            <img src={BottlesIcon} alt="Bottles" className={classes.storeIcon}/>
                        </Paper>
                    </Grid>
                    <Hidden smDown>
                        <Grid item sm={12} md={6}>
                            <img src={Cups} alt="Cups" className={classes.imgStore} />
                        </Grid>
                    </Hidden>
                    <Hidden smDown>
                        <Grid item sm={12} md={6}>
                            <img src={Barrils} alt="Cups" className={classes.imgStore}/>
                        </Grid>
                    </Hidden>
                    <Grid item sm={12} md={6} className={classes.gridMaxWidth}>
                        <Paper className={classes.control}>
                            <p>Visita nuestras redes <br/> Siguenos</p>
                            <img src={FacebookIcon} alt="Bottles" className={classes.socialMediaIcon}/>
                            <img src={InstagramIcon} alt="Bottles" className={classes.socialMediaIcon}/>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default InfoContainer;